import Keycloak from 'keycloak-js';
import { environment } from '../../environments/environment';
import { AllUserRoles } from '../../models/enum/all-user-roles';

export const localAuthEnabled = 'localAuth' in environment && environment.localAuth === true;

const configuredLocalRoles = 'localRoles' in environment && Array.isArray(environment.localRoles) ? environment.localRoles : [];
const localRoles = configuredLocalRoles.filter((role): role is AllUserRoles => Object.values(AllUserRoles).includes(role as AllUserRoles));

export function hasLocalRole(role: string): boolean {
    return localRoles.includes(role as AllUserRoles);
}

export function createLocalKeycloak(): Keycloak {
    return {
        authenticated: true,
        realmAccess: { roles: localRoles },
        resourceAccess: {
            [environment.keyCloakClientId]: { roles: localRoles }
        },
        hasRealmRole: hasLocalRole,
        hasResourceRole: hasLocalRole,
        login: async (): Promise<void> => {},
        logout: async (): Promise<void> => {},
        updateToken: async (): Promise<boolean> => true
    } as unknown as Keycloak;
}
